// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__lSzlj","header":"ReportDetails_header__2z4LH","title":"ReportDetails_title__2si2c","left":"ReportDetails_left__2KMCx"};